import { FC } from 'react';

import { ICommonRightSidebarProps } from 'APP/main/RightSidebarManager/RightSidebarManager.types';
import Entities from 'STORE';

export const openRightSidebarItem = <TParams>(
  key: string,
  component: FC<ICommonRightSidebarProps<TParams>>,
  componentProps?: TParams
): void => {
  Entities.RightSidebar.openRightSidebarItem(key, component, componentProps);
};
